import {
  PERITADOR_ACT_GET_PDF_BEGIN,
  PERITADOR_ACT_GET_PDF_SUCCESS,
  PERITADOR_ACT_GET_PDF_FAILURE,
  PERITADOR_ACT_GET_PDF_DISMISS_ERROR,
} from './constants'
import axios from 'axios'
import { REACT_APP_API } from '../../../common/config'

export function actGetPdf(args = {}) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PERITADOR_ACT_GET_PDF_BEGIN,
    })

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(`${REACT_APP_API}/PDF/peritador/generate`, args, {
        responseType: 'text/html',
      })

      doRequest.then(
        (res) => {
          dispatch({
            type: PERITADOR_ACT_GET_PDF_SUCCESS,
          })
          resolve(res)
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PERITADOR_ACT_GET_PDF_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissActGetPdfError() {
  return {
    type: PERITADOR_ACT_GET_PDF_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PERITADOR_ACT_GET_PDF_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        actGetPdfPending: true,
        actGetPdfError: null,
      }

    case PERITADOR_ACT_GET_PDF_SUCCESS:
      // The request is success
      return {
        ...state,
        actGetPdfPending: false,
        actGetPdfError: null,
      }

    case PERITADOR_ACT_GET_PDF_FAILURE:
      // The request is failed
      return {
        ...state,
        actGetPdfPending: false,
        actGetPdfError: action.data.error,
      }

    case PERITADOR_ACT_GET_PDF_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        actGetPdfError: null,
      }

    default:
      return state
  }
}
